import React from "react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import BeforeAfterSlider from "@/components/BeforeAfterSlider";
import SectionCTA from "@/components/SectionCTA";
import { PROJECTS, IMG } from "@/data/site";
import { MapPin } from "lucide-react";

export default function Projects() {
  return (
    <div data-testid="projects-page">
      <Seo title="Projects & Case Studies" description="Detailed before-and-after tiling and bathroom project case studies by Rossi Ceramics across Stockport and the North West." />
      <PageHero eyebrow="Case studies" title="Projects & transformations" subtitle="Explore how we approach each space — from the room before to the finished result." image={IMG.floor[1]} />

      <section className="container-rossi py-20 space-y-20">
        {PROJECTS.map((p, i) => (
          <Reveal key={p.name}>
            <div className={`grid lg:grid-cols-2 gap-10 items-center ${i % 2 ? "lg:[&>*:first-child]:order-2" : ""}`}>
              <div className="card-lux p-3">
                <BeforeAfterSlider before={p.before} after={p.after} beforeAlt={`${p.name} before`} afterAlt={`${p.name} after`} height="h-[360px]" />
              </div>
              <div>
                <span className="eyebrow">{p.service}</span>
                <h2 className="font-serif text-3xl sm:text-4xl text-rossi-cream mt-3 leading-tight">{p.name}</h2>
                <p className="flex items-center gap-2 text-sm text-rossi-stone mt-2"><MapPin size={15} className="text-rossi-gold" /> {p.area}</p>
                <p className="mt-4 text-rossi-cream/75 leading-relaxed">{p.summary}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </section>

      <SectionCTA />
    </div>
  );
}
